module.exports = __webpack_public_path__ + "static/media/Follower_Button-15.f7521eab.png";